var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notification.ShowNotification)?_c('div',{staticClass:"notification"},[_c('p',[_vm._v(_vm._s(_vm.notification.Content)+" "),(_vm.notification.Link)?_c('a',{attrs:{"href":_vm.notification.Link,"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.notification.LinkTitle)+"\n    ")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }